import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import {
  AnalyticsFetchThreadsResponseDataItem,
  AnalyticsFetchThreadsSentimentType,
  AnalyticsFetchThreadsVectorType,
} from 'src/services/__generated__/api'
import { UseGetPositiveLiveNotificationsQueryParams } from './interfaces/useGetPositiveLiveNotificationsQuery.interface'

const getPositiveLiveNotifications = async (
  lastDate?: string,
  limit?: number
): Promise<AnalyticsFetchThreadsResponseDataItem[] | null> => {
  if (!lastDate || !limit) {
    return null
  }

  const {
    data: { data },
  } = await AnalyticsApi.v1Private.analyticsFetchThreadsList({
    lastDate,
    limit,
    sentiment: AnalyticsFetchThreadsSentimentType.POS,
    vector: AnalyticsFetchThreadsVectorType.Desc,
  })

  return data ?? null
}

export const useGetPositiveLiveNotificationsQuery = (
  params: UseGetPositiveLiveNotificationsQueryParams
) => {
  return useQuery({
    queryFn: () => getPositiveLiveNotifications(params.lastDate, params.limit),
    queryKey: [
      QueryKey.GET_POSITIVE_LIVE_NOTIFICATIONS,
      ...Object.values(params),
    ],
    refetchInterval: Infinity,
  })
}
